// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fb988c08","220":"9e9d91aa"}[chunkId] + ".chunk.css";
};